export default ({ FONT_SIZES }) => ({
  container: {
    ...FONT_SIZES.BODY_LARGE.STYLE,
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    width: '330px',
    alignItems: 'center',
    animation: '0.5s fadeIn',
    position: 'relative'
  },
  pendingOverlay: {
    animation: '0.3s fadeIn',
    position: 'absolute',
    left: '0',
    top: '0',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.5)'
  },
  '@keyframes fadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 }
  }
})
